import { createGlobalStyle } from 'styled-components'

export const GlobalModalStyles = createGlobalStyle`
  html.lock-scroll {
    overflow: hidden !important;
  }
`
